import { isSafeRedirectPath } from '@kit/shared/utils';

/**
 * Builds an auth callback URL that safely retains the page the user intended
 * to reach after authentication. This is shared by auth methods that send the
 * user away from the current browser page, such as magic links.
 */
export function buildAuthCallbackRedirectUrl(params: {
  origin: string;
  callback: string;
  returnPath: string;
}): string {
  const url = new URL(params.callback, params.origin);

  if (isSafeRedirectPath(params.returnPath)) {
    url.searchParams.set('next', params.returnPath);
  }

  return url.toString();
}
